import K from "utilities/constants";
import User from "models/user/user";

export default class Request {
  constructor(
    relativeURL,
    method = K.Network.Method.GET,
    body = null,
    defaultHeaderType = K.Network.Header.Type.Json,
    headers = {}
  ) {
    const token = User.getToken();
    headers = {
      ...(defaultHeaderType === K.Network.Header.Type.Json
        ? K.Network.Header.Default(token)
        : K.Network.Header.Authorization(token)),
      ...headers,
    };
    this.url = K.Network.URL.BaseAPI + relativeURL;
    this.method = method;
    this.body = body;
    this.headers = headers;
  }

  // User calls.
  static loginUser(roleType, email, password) {
    const body = {
      roleType,
      email,
      password,
    };
    return new Request(
      K.Network.URL.LoginUser,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }

  // login with google
  static loginWithGoogle(data) {
    const body = {
      ...data,
    };
    return new Request(
      K.Network.URL.LoginWithGoogle,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }

  static forgotPassword(email) {
    const body = {
      email,
    };
    return new Request(
      K.Network.URL.ForgotPassword,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }

  static resetPassword(data) {
    const body = {
      ...data,
    };
    return new Request(
      K.Network.URL.ResetPassword,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }

  static getAllRelationship() {
    return new Request(
      K.Network.URL.GetAllRelationship,
      K.Network.Method.GET,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static getRelationshipType() {
    return new Request(
      K.Network.URL.GetRelationshipTypes,
      K.Network.Method.GET,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static getAllTopics() {
    return new Request(
      `${K.Network.URL.GetAllTopics}`,
      K.Network.Method.GET,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static createNewDiary(values) {
    const body = {
      ...values,
    };
    return new Request(
      K.Network.URL.CreateDiary,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }

  static register(values) {
    const body = {
      ...values,
    };
    return new Request(
      K.Network.URL.RegisterUser,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static verifyUser(values) {
    const body = {
      ...values,
    };
    return new Request(
      K.Network.URL.VerifyUser,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static resendVerificationEmail(values) {
    const body = { ...values };
    return new Request(
      K.Network.URL.ResendVerificationEmail,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static getUserDetails() {
    return new Request(
      K.Network.URL.GetUserDetails,
      K.Network.Method.GET,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static getUserRoles() {
    return new Request(
      `${K.Network.URL.GetUserRoles}?key=Diarist`,
      K.Network.Method.GET,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static getDiaryTopics(id) {
    return new Request(
      `${K.Network.URL.GetDiaryTopics}/${id}`,
      K.Network.Method.GET,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static getAllDiariesList(archive) {
    return new Request(
      archive
        ? `${K.Network.URL.GetAllDiaries}?archived=true`
        : K.Network.URL.GetAllDiaries,
      K.Network.Method.GET,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static AddType(values) {
    const body = {
      ...values,
    };
    return new Request(
      K.Network.URL.AddType,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static addEntry(values) {
    const body = {
      ...values,
    };
    return new Request(
      K.Network.URL.AddEntry,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }

  static getMessageResolved(values) {
    const body = {
      ...values,
    };
    return new Request(
      K.Network.URL.ReviseEntry,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json
    );
  }

  static getDraftedEntries(id) {
    return new Request(
      `${K.Network.URL.GetAllDraftedEntries}/${id}`,
      K.Network.Method.GET,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }

  static deleteEntry(id) {
    return new Request(
      `${K.Network.URL.DeleteEntry}/${id}`,
      K.Network.Method.DELETE,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static releaseEntries(id) {
    const values = { ...id };
    return new Request(
      K.Network.URL.ReleaseAllEntries,
      K.Network.Method.PUT,
      values,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static UpdateInvite(values) {
    const body = {
      ...values,
    };
    return new Request(
      K.Network.URL.UpdateInvite,
      K.Network.Method.PUT,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static UpdateUserDetails(values) {
    const body = {
      ...values,
    };
    return new Request(
      K.Network.URL.UpdateUserDetails,
      K.Network.Method.PUT,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static getDiariesEntries(data) {
    const body = { ...data };
    return new Request(
      K.Network.URL.GetAllEntries,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }

  static UpdatePassword(values) {
    const body = {
      ...values,
    };
    return new Request(
      K.Network.URL.UpdatePassword,
      K.Network.Method.PUT,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static getDiary(data) {
    return new Request(
      `${K.Network.URL.GetDiary}?${data}`,
      K.Network.Method.GET,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }

  static LockUnlockDiary(values) {
    const body = {
      ...values,
    };
    return new Request(
      K.Network.URL.LockUnlockDiary,
      K.Network.Method.PUT,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static uploadProfileImage(values) {
    const body = values;
    return new Request(
      K.Network.URL.UploadProfileImage,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.File,
      {}
    );
  }
  static getProfileImage() {
    return new Request(
      K.Network.URL.GetProfileImage,
      K.Network.Method.GET,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static notifyDiaristAboutLock(data) {
    const body = { ...data };
    return new Request(
      K.Network.URL.NotifyDiaristAboutLock,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }

  static removeProfileImage() {
    return new Request(
      K.Network.URL.RemoveProfileImage,
      K.Network.Method.DELETE,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }

  static getDraftedStatus(data) {
    return new Request(
      `${K.Network.URL.DraftedEntriesStatus}?${data}`,
      K.Network.Method.GET,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }

  static updateUserStatus(values) {
    return new Request(
      `${K.Network.URL.UpdateUserStatus}?${values}`,
      K.Network.Method.PUT,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static sendReminderEmail(id) {
    return new Request(
      `${K.Network.URL.ReminderEmail}/${id}`,
      K.Network.Method.POST,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }

  static getNotifications(data) {
    const body = { ...data };
    return new Request(
      K.Network.URL.GetNotification,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }

  //add global topic to dairy topic
  static addGlobalTopicToDiary(data) {
    const body = {
      ...data,
    };
    return new Request(
      K.Network.URL.AddGlobalTopicToDiary,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static markNotiAsRead(data) {
    const body = {
      ...data,
    };
    return new Request(
      K.Network.URL.MarkAsRead,
      K.Network.Method.PUT,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }

  static resetCountNotify() {
    return new Request(
      K.Network.URL.ResetCount,
      K.Network.Method.PUT,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }

  //SEDN FEEDBACK
  static sendFeedback(data) {
    const body = { ...data };
    return new Request(
      K.Network.URL.sendFeedback,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }

  static globalSearch(values) {
    const body = {
      ...values,
    };
    return new Request(
      K.Network.URL.GlobalSearch,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }

  static getAllPersonalityTypes() {
    return new Request(
      K.Network.URL.PersonalityTypes,
      K.Network.Method.GET,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static updatePersonalityType(body) {
    const values = { ...body };
    return new Request(
      K.Network.URL.UpdatePersonalityType,
      K.Network.Method.PUT,
      values,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static declinedDiaryInvite(values) {
    const body = {
      ...values,
    };
    return new Request(
      K.Network.URL.DeclindOrBlockedDiaryInvite,
      K.Network.Method.PUT,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static getSettings() {
    return new Request(
      `${K.Network.URL.GetGlobalSettings}`,
      K.Network.Method.GET,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static resendJournalInvite(id) {
    return new Request(
      `${K.Network.URL.ResendJournalInvite}?${id}`,
      K.Network.Method.PUT,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static createCheckoutSession(body) {
    return new Request(
      K.Network.URL.CreateCheckoutSession,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static modifyCheckoutSession(body) {
    return new Request(
      K.Network.URL.ModifySubSession,
      K.Network.Method.POST,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }
  static cancelSubscription() {
    return new Request(
      K.Network.URL.CancelSubscription,
      K.Network.Method.PUT,
      {},
      K.Network.Header.Type.Json,
      {}
    );
  }
  static archiveUnArchiveJournal(body) {
    return new Request(
      K.Network.URL.ArchiveUnarchiveJournal,
      K.Network.Method.PUT,
      body,
      K.Network.Header.Type.Json,
      {}
    );
  }
}
